import styled from "styled-components";

export const LoaderContainer = styled.div`
display: flex;
align-items: flex-end;
justify-content: center;
.overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.1);
    z-index: 99999999;
}

.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}


border-color: #00c58f transparent #00c58f transparent;

.loading-spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 3px;
    border-color: #00c58f transparent #00c58f transparent;
    border-top-color: #fff;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
`